<script lang="ts">
  import { page } from "$app/stores";
  import Translate from "./locale.svelte";
  import Sprite from "./sprite.svelte";

  export let title = "";
  export let subtitle = "";
  export let returnLink: string | null = null;

  $: pageTheme = $page.data.pageTheme;
</script>

<svelte:head>
  <style>
    :root {
      --app-bar-height: calc(var(--sp) * 48);
    }
  </style>
</svelte:head>

<header style="--app-bar-theme-color: {pageTheme};">
  {#if returnLink}
    <a class="Return" href={returnLink}>
      <Sprite icon="icon-return" size={24} />
      <span class="sr-only">
        <Translate label="appbar.returnLink" />
      </span>
    </a>
  {/if}

  <div class="TitleBox">
    <h1 class="Title">
      <Translate label={title} />
    </h1>

    {#if subtitle}
      <h2 class="Subtitle">
        <Translate label={subtitle} />
      </h2>
    {/if}
  </div>

  <menu>
    <slot />
  </menu>
</header>

<style>
  header {
    border-top: env(safe-area-inset-top, 0px) solid var(--app-bar-theme-color, white);
    align-items: center;
    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.25);
    display: flex;
    justify-content: center;
    width: 100%;
    z-index: var(--z-appbar);
  }

  .TitleBox {
    flex: 1 1;
    padding-block: 16px;
    padding-left: max(env(safe-area-inset-left), var(--outer-padding));
    padding-right: max(env(safe-area-inset-right), var(--outer-padding));
    position: relative;
  }

  .Title {
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0.12em;
    line-height: 1;
    margin: 0;
    text-transform: uppercase;
  }

  .Subtitle {
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0.12em;
    line-height: 1;
    margin: 4px 0 0 0;
    text-transform: uppercase;
  }

  .Return {
    padding: 12px; /* 24 + 12 + 12 = 48 */
  }

  .Return + .TitleBox {
    padding-left: 2px;
  }

  menu {
    flex: 0 1;
    display: flex;
    padding-right: 16px;
  }
</style>
